// extracted by mini-css-extract-plugin
module.exports = {"myHeader":"style_myHeader__B1Coc"};